import { ChangeDetectionStrategy, Component, effect, model, output, untracked, viewChild } from '@angular/core';
import { PositionSelectComponent } from 'src/app/shared/components/position-select.component';
import { Posizione } from 'src/app/shared/models/posizione.model';

@Component({
  selector: 'app-spostafascicolo-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Sposta in un altro fascicolo" [(visible)]="visible" [modal]="true" (onHide)="hide.emit($event)">
    <app-position-select [noExpired]="true" [(ngModel)]="newPosizione" #copiaSelect="ngModel"></app-position-select>
    <p-footer>
    <div class="grid">
      <div class="col-9"></div>
      <div class="col-3">
        <div class="flex">
          <button pButton type="button" icon="pi pi-times" label="Annulla"
              (click)="hide.emit()" class="p-button-secondary"></button>
          <button pButton type="button" icon="pi pi-check" label="Sposta" (click)="confirm.emit(newPosizione)"
              [disabled]="copiaSelect.invalid"></button>
        </div>
      </div>
    </div>
  </p-footer>
  </p-dialog>
  `,
  styles: [`
  label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  .vietata-checkbox { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  label:first-of-type { margin-top: 0; }
  `]
})
export class SpostaFascicoloDialogComponent {
  visible = model.required<boolean>();
  hide = output();
  confirm = output<Posizione[]>();
  positionComponent = viewChild.required(PositionSelectComponent);

  public newPosizione: Posizione[] = [];

  constructor() {
    effect(() => {
      if (this.visible()) {
        this.newPosizione = [];
        untracked(() => this.positionComponent().clearForm());
      }
    }, { allowSignalWrites: true });
  }
}
